import 'react-app-polyfill/stable'
import React from 'react'
// import './utils'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import './lang/i18n'
//  style
import './style/tailwind.output.css'
import './style/index.less'

//  route path
import { PATH } from './constants/PATH'
//  store
import store from './store'
//  component
import InitialApp from './Initial'
import ErrorBoundary from './components_renew/ErrorBoundary'
import NoMatch from './pages_renew/NoMatch'
import Version from './pages_renew/Others/Version'
import Login from './pages_renew/Login'
import Protocol from './pages_renew/Others/Protocol'
import Frame from './pages_renew/Frame'
import ImageFrameWithBtn from './pages_renew/Frame/ImageFrameWithBtn'
import DeliveryConfirm from './pages_renew/Delivery'
import Address from './pages_renew/Address'
import Mall from './pages_renew/Mall'
import Agreement from './pages_renew/Agreement'
import Integral from './pages_renew/Integral'
import Tutorial from './pages_renew/Tutorial'
import Turntable from './pages_renew/Turntable'
import LotteryLog from './pages_renew/Turntable/LotteryLog'
import CardGame from './pages_renew/CardGame'
// import Task from './pages/Task'   //  keep
// import Lottery from './pages_renew/Lottery'  //  keep
import Events from './pages_renew/Events'
import MessageList from './pages_renew/Message/MessageList'
import MessageDetails from './pages_renew/Message/MessageDetails'
import MessageText from './pages_renew/Message/MessageText'
import MessageAgreement from './pages_renew/Message/MessageAgreement'
import MessageAgreementSuccess from './pages_renew/Message/MessageAgreementSuccess'
import RedPacket from './pages_renew/RedPacket'

// v3
import Entry_v3 from './renew_v3/Entry'

export default () => {
  return <ErrorBoundary>
    <Provider store={store}>
      <Router>
        {/* 处理全局应用，初始化某些第三方库会在InitialApp里面处理 */}
        <InitialApp>
          <Switch>
            {/* 登陆交由客户端去处理 */}
            {/*<Route path={PATH.LOGIN} component={Login} />*/}
            <Route path={PATH.PROTOCOL} component={Protocol}/>
            <Route path={PATH.MALL} component={Mall}/>
            <Route path={PATH.INTEGRAL} component={Integral}/>
            <Route path={PATH.TUTORIAL} component={Tutorial}/>
            <Route path={PATH.DELIVERY_CONFIRM} component={DeliveryConfirm}/>
            <Route path={PATH.ADDRESS.INDEX} component={Address}/>
            {/* Agreement */}
            <Route path={PATH.AGREEMENT.INDEX} component={Agreement}/>
            {/* Message */}
            <Route path={`${PATH.MESSAGE}/text`} component={MessageText}/>
            <Route path={`${PATH.MESSAGE}/agreement-success`} component={MessageAgreementSuccess}/>
            <Route path={`${PATH.MESSAGE}/agreement`} component={MessageAgreement}/>
            <Route path={`${PATH.MESSAGE}/:type/:id`} component={MessageDetails}/>
            <Route path={PATH.MESSAGE} component={MessageList}/>

            <Route path={`${PATH.FRAME}/:src/:title`} component={Frame}/>
            <Route path={`${PATH.FRAME}/:src`} component={Frame}/>
            <Route path={`${PATH.IMAGE_FRAME_BTN}/:src/:title`} component={ImageFrameWithBtn}/>
            <Route path={`${PATH.IMAGE_FRAME_BTN}/:src`} component={ImageFrameWithBtn}/>

            <Route path={PATH.TURNTABLE} component={Turntable}/>
            {/*<Route path={PATH.TASK} component={Task}/>*/}
            <Route path={PATH.LOTTERY_LOG} component={LotteryLog}/>
            <Route path={PATH.CARD_GAME} component={CardGame}/>
            {/*<Route path={PATH.LOTTERY.INDEX} component={Lottery}/>*/}
            <Route path={PATH.VERSION} component={Version}/>
            <Route path={PATH.EVENTS.INDEX} component={Events}/>

            <Route path={PATH.RED_PACKET} component={RedPacket}/>
            {
              process.env.NODE_ENV === 'development'
              &&  <Route path={PATH.LOGIN} component={Login}/>
            }

            {/*v3*/}
            <Route path={'/v3'} component={Entry_v3}/>
            <Route component={NoMatch}/>
          </Switch>
        </InitialApp>
      </Router>
    </Provider>
  </ErrorBoundary>
}
